function getRandomInt(min, max) {
  return Math.floor(Math.random() * (max - min)) + min
}

const state = () => ({
  bannerAd: null
})

const mutations = {
  setBannerAd(state, ads) {
    const bannerAds = []
    for (let i = 0; i < ads.length; i++) {
      const item = ads[i]
      if (item.type === 'banner') {
        bannerAds.push(item)
      }
    }

    if (bannerAds.length > 0) {
      state.bannerAd = bannerAds[getRandomInt(0, bannerAds.length)]
    }
  }
}

const actions = {
  async getAdConfig({ state, commit, dispatch }, { $axios }) {
    try {
      const res = await $axios.get(`https://cdn.just4fun.sg/resource/tga-config/tgaAdConfig.json?v=${parseInt(new Date().getTime() / 10000000)}`)
      // const res = await $axios.get(`http://192.168.50.104:5501/tgaAdConfig.json?v=${new Date().getTime()}`)

      if (res && res.data && res.data.length > 0) {
        commit("setBannerAd", res.data)
      }

    } catch (error) {
      console.log('get tgaAdConfig error', error)
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/adConfig.js